interface Member {
  role: "gm" | "gm_assistant" | "pc" | "audience";
  characterIds?: string[];
}

export default function RosterList({ members }: { members: Record<string, Member> }) {
  const entries = Object.entries(members);
  return (
    <ul className="space-y-1 text-sm">
      {entries.map(([uid, m]) => (
        <li
          key={uid}
          className="flex items-center justify-between rounded border border-border bg-card px-2 py-1"
        >
          <span className="font-mono text-xs text-muted-foreground">{uid}</span>
          <span className="text-foreground">{m.role}</span>
        </li>
      ))}
    </ul>
  );
}
